import { Component, EventEmitter, Input, Output } from '@angular/core'
import { ViewportsConfig } from 'src/app/merchandise/block-editor/block-editor.service'
import { NgIf, NgFor, NgClass } from '@angular/common';

@Component({
    selector: 'app-viewport-toggle',
    templateUrl: './viewport-toggle.component.html',
    styleUrls: ['./viewport-toggle.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        NgFor,
        NgClass,
    ],
})
export class ViewportToggleComponent {
	@Input() viewportsConfig: ViewportsConfig
	@Output() selectedViewport = new EventEmitter<number>()

	resize(size: number) {
		this.selectedViewport.emit(size)
	}
}
